import React, { useEffect, useState } from "react";
import { fetchTopQuotes } from "./api";
import HeroLink from "./HeroLink";
import RoryCourses from "./RoryCourses";
import SignupBox from "./SignupBox";
import UpvoteButton from "./UpvoteButton";
import { RoryQuote } from "./types";

const Top = () => {
  const [quotes, setQuotes] = useState<RoryQuote[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchTopQuotes()
      .then(setQuotes)
      .catch(() => setError("The chart could not be loaded. Please try again in a moment."));
  }, []);

  // A vote can move a quote up the chart, so the chart moves with it.
  const onVoted = (id: number, votes: number) =>
    setQuotes((list) =>
      list && [...list.map((q) => (q.id === id ? { ...q, votes } : q))].sort((a, b) => b.votes - a.votes || a.number - b.number),
    );

  return (
    <div className="rq">
      <section className="rq-hero rq-hero--centre">
        <div className="rq-wrap">
          <a href="/rory-quotes" className="rq-home-link">
            <span className="rq-hero__avatar rq-hero__avatar--link">
              <img src="/rory-quotes/rory-sketch.png" alt="" width="112" height="112" />
            </span>
            <span>Rory Quote Finder</span>
          </a>
          <h1 className="rq-hero__title">
            The Top 10 <em className="rq-hl">Rory Sutherland Quotes</em>
          </h1>
          <div className="rq-hero__links rq-hero__links--centre">
            <HeroLink to="/rory-quotes">Rory Quote Finder</HeroLink>
          </div>
        </div>
      </section>
      <section className="rq-top">
        <div className="rq-wrap">
          {error && <p role="alert" className="rq-finder__error">{error}</p>}
          {!quotes && !error && <p className="rq-top__loading">Counting the votes…</p>}
          {quotes && (
            <ol className="rq-top__list">
              {quotes.map((quote, i) => (
                <li key={quote.id} className="rq-offset rq-top__item">
                  <span className={`rq-top__rank ${i < 3 ? "is-podium" : ""}`} aria-hidden="true">
                    {i + 1}
                  </span>
                  <div className="rq-top__body">
                    <blockquote>
                      <a href={quote.path}>{quote.text}</a>
                    </blockquote>
                    <p className="rq-top__source">
                      Rory Sutherland{quote.display_source && <span> · {quote.display_source}</span>}
                    </p>
                  </div>
                  <UpvoteButton quote={quote} onVoted={onVoted} />
                </li>
              ))}
            </ol>
          )}
          <p className="rq-top__cta">
            <a href="/rory-quotes" className="rq-btn rq-btn--blue">
              Find your own quote
            </a>
          </p>
        </div>
      </section>
      <SignupBox />
      <RoryCourses />
    </div>
  );
};

export default Top;
